/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountEnabledPatchForm } from '../model/models';
import { AssociaComuneForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { InfoPersonaliPatchForm } from '../model/models';
import { OperatoreComuneCreationForm } from '../model/models';
import { OperatoreComuneDTO } from '../model/models';
import { OperatoreComuneListFilter } from '../model/models';
import { OperatoreComuneUpdateForm } from '../model/models';
import { OperatoreStatoAccessoDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelOperatoreComuneCompactDTO } from '../model/models';
import { PagedModelUserCompactDTO } from '../model/models';
import { UserSelectShortcutFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AssociaComuneToOperatoreComuneRequestParams {
    userId: string;
    associaComuneForm: AssociaComuneForm;
}

export interface AvviaResetPasswordOperatoreComuneRequestParams {
    userId: string;
}

export interface ClearBruteForceLockoutOperatoreComuneRequestParams {
    userId: string;
}

export interface CreateOperatoreComuneRequestParams {
    operatoreComuneCreationForm: OperatoreComuneCreationForm;
}

export interface DeleteOperatoreComuneRequestParams {
    userId: string;
}

export interface EditInfoPersonaliOperatoreComuneRequestParams {
    userId: string;
    infoPersonaliPatchForm: InfoPersonaliPatchForm;
}

export interface GetOperatoreComuneDetailRequestParams {
    userId: string;
}

export interface GetResetPasswordLinkOperatoreComuneRequestParams {
    userId: string;
}

export interface GetStatoAccessoOperatoreComuneRequestParams {
    userId: string;
}

export interface GetVerificationLinkOperatoreComuneRequestParams {
    userId: string;
}

export interface ListOperatoriComuneRequestParams {
    filter: OperatoreComuneListFilter;
    pageable: Pageable;
}

export interface ReinviaVerificaOperatoreComuneRequestParams {
    userId: string;
}

export interface SelectOperatoreComuneRequestParams {
    shortcut: UserSelectShortcutFilter;
    pageable: Pageable;
}

export interface SetAccountEnabledOperatoreComuneRequestParams {
    userId: string;
    accountEnabledPatchForm: AccountEnabledPatchForm;
}

export interface UpdateOperatoreComuneRequestParams {
    userId: string;
    operatoreComuneUpdateForm: OperatoreComuneUpdateForm;
}


export interface OperatoriComuneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Associa un comune all\&#39;utente OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro).
     * Idempotente. Applica la matrice authority-target: 409 se il target ha authority incompatibile.
     * @endpoint post /api/v1/gestione/operatori-comune/{user_id}/associa-comune
* @param requestParameters
     */
    associaComuneToOperatoreComune(requestParameters: AssociaComuneToOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<OperatoreComuneDTO>;

    /**
     * Invia l\&#39;email di reset password a un OP_COMUNE.
     * SUPERADMIN o delegato nel proprio perimetro. Solo su un account attivo; emette un token nuovo, quindi un link di reset copiato in precedenza smette di funzionare.
     * @endpoint post /api/v1/gestione/operatori-comune/{user_id}/reset-password
* @param requestParameters
     */
    avviaResetPasswordOperatoreComune(requestParameters: AvviaResetPasswordOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Cancella il brute-force lockout Keycloak di un OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro).
     * Sblocca un OP_COMUNE bloccato da Keycloak per troppi tentativi di login falliti. 404 privacy se target non OP_COMUNE; 400 se l\&#39;utente non ha keycloakSubjectId. Erede del legacy DELETE /api/v1/user/{id}/brute-force-lockout.
     * @endpoint delete /api/v1/gestione/operatori-comune/{user_id}/brute-force-lockout
* @param requestParameters
     */
    clearBruteForceLockoutOperatoreComune(requestParameters: ClearBruteForceLockoutOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Crea un nuovo utente OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro). comuni_ids opzionale.
     * Endpoint verticale per la creazione OP_COMUNE. Authority forzata, comuni_ids nullable/empty consentito (utente fantasma lecito). Riusa la persistenza condivisa con addUser legacy.
     * @endpoint post /api/v1/gestione/operatori-comune
* @param requestParameters
     */
    createOperatoreComune(requestParameters: CreateOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<OperatoreComuneDTO>;

    /**
     * Cancella un OP_COMUNE (SUPERADMIN).
     * Revoca sessioni KC + rimozione utente KC + rimozione associazioni (comuni_gestiti, push token) + delete locale. 404 privacy se target non OP_COMUNE; 409 se ha dati storici referenziati da FK RESTRICT (usare la disabilitazione come alternativa). Erede del legacy DELETE /api/v1/user/{id}.
     * @endpoint delete /api/v1/gestione/operatori-comune/{user_id}
* @param requestParameters
     */
    deleteOperatoreComune(requestParameters: DeleteOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica nome/cognome di un OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro).
     * SUPERADMIN o delegato nel proprio perimetro. Campi null &#x3D; no-op per quel campo. Almeno uno tra nome/cognome richiesto (400 info_personali_almeno_un_campo). Sync KC firstName/lastName best-effort. 404 privacy se target non OP_COMUNE.
     * @endpoint patch /api/v1/gestione/operatori-comune/{user_id}/info
* @param requestParameters
     */
    editInfoPersonaliOperatoreComune(requestParameters: EditInfoPersonaliOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<OperatoreComuneDTO>;

    /**
     * Detail di un utente OP_COMUNE con comuni_gestiti espansi (SUPERADMIN o delegato nel proprio perimetro).
     * 404 privacy-preserving se l\&#39;utente non e\&#39; OP_COMUNE.
     * @endpoint get /api/v1/gestione/operatori-comune/{user_id}
* @param requestParameters
     */
    getOperatoreComuneDetail(requestParameters: GetOperatoreComuneDetailRequestParams, extraHttpRequestParams?: any): Observable<OperatoreComuneDTO>;

    /**
     * Genera il link di reset password per un OP_COMUNE (SUPERADMIN).
     * Audience SUPERADMIN. Verbo POST per side-effect server-side (genera/persiste un JTI). 404 privacy se target non OP_COMUNE.
     * @endpoint post /api/v1/gestione/operatori-comune/{user_id}/get-reset-password-link
* @param requestParameters
     */
    getResetPasswordLinkOperatoreComune(requestParameters: GetResetPasswordLinkOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Stato di accesso di un OP_COMUNE letto da Keycloak (SUPERADMIN o delegato nel proprio perimetro).
     * Espone il blocco per tentativi di accesso falliti, che vive solo in Keycloak e non è rispecchiato da alcuna colonna locale: serve al backoffice per offrire lo sblocco solo a chi è davvero bloccato. Lettura separata dal dettaglio perché interroga Keycloak: un fermo di Keycloak dà 400 qui senza impedire il caricamento della scheda operatore. Operatore senza identità Keycloak → stato vuoto (niente da bloccare), non un errore. 404 privacy se target non OP_COMUNE.
     * @endpoint get /api/v1/gestione/operatori-comune/{user_id}/stato-accesso
* @param requestParameters
     */
    getStatoAccessoOperatoreComune(requestParameters: GetStatoAccessoOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<OperatoreStatoAccessoDTO>;

    /**
     * Genera il link di verifica email per un OP_COMUNE (SUPERADMIN).
     * Audience SUPERADMIN. Verbo POST per side-effect server-side (genera/persiste un JTI). 404 privacy se target non OP_COMUNE.
     * @endpoint post /api/v1/gestione/operatori-comune/{user_id}/get-verification-link
* @param requestParameters
     */
    getVerificationLinkOperatoreComune(requestParameters: GetVerificationLinkOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Lista paginata operatori OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro).
     * Filtri opzionali: q (email/nome/cognome), comune_id, enabled. Default sort: email ASC, size 20. Projection JPQL: numero_comuni_gestiti precomputato.
     * @endpoint get /api/v1/gestione/operatori-comune
* @param requestParameters
     */
    listOperatoriComune(requestParameters: ListOperatoriComuneRequestParams, extraHttpRequestParams?: any): Observable<PagedModelOperatoreComuneCompactDTO>;

    /**
     * Reinvia l\&#39;email di attivazione a un OP_COMUNE.
     * SUPERADMIN o delegato nel proprio perimetro. Solo con un invito in attesa; riusa il token dell\&#39;invito, quindi un link di attivazione copiato in precedenza resta valido.
     * @endpoint post /api/v1/gestione/operatori-comune/{user_id}/reinvia-verifica
* @param requestParameters
     */
    reinviaVerificaOperatoreComune(requestParameters: ReinviaVerificaOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Shortcut select prefiltrato su OP_COMUNE (SUPERADMIN).
     * Filtri: q, comune_id, account_enabled. Parametro authority NON esposto: il backend forza Set.of(OP_COMUNE) e ignora silenziosamente eventuali query param ?authority&#x3D;...
     * @endpoint get /api/v1/gestione/operatori-comune/select
* @param requestParameters
     */
    selectOperatoreComune(requestParameters: SelectOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<PagedModelUserCompactDTO>;

    /**
     * Soft-delete o riattivazione di un OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro).
     * SUPERADMIN o delegato nel proprio perimetro. Idempotente: PATCH con stesso valore di enabled non chiama KC. Su disable revoca anche le sessioni KC. 404 privacy se target non OP_COMUNE.
     * @endpoint patch /api/v1/gestione/operatori-comune/{user_id}/account-enabled
* @param requestParameters
     */
    setAccountEnabledOperatoreComune(requestParameters: SetAccountEnabledOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Replace dei comuni_gestiti di un OP_COMUNE (SUPERADMIN o delegato nel proprio perimetro).
     * SUPERADMIN: comuni_ids e\&#39; l\&#39;insieme finale, [] ammesso (utente fantasma lecito). Delegato: comuni_ids descrive solo i propri comuni (403 se ne contiene altri), i comuni esterni del collega sono preservati, un risultato vuoto da\&#39; 422. comuni_ids&#x3D;null &#x3D; no-op. 404 privacy se target non OP_COMUNE o fuori perimetro.
     * @endpoint put /api/v1/gestione/operatori-comune/{user_id}
* @param requestParameters
     */
    updateOperatoreComune(requestParameters: UpdateOperatoreComuneRequestParams, extraHttpRequestParams?: any): Observable<OperatoreComuneDTO>;

}
